import CitaLinkTelefono from "./CitaLinkTelefono";
import CitaLinkEmail from "./CitaLinkEmail";
import CitaLinkPersona from "./CitaLinkPersona";

/**
 * Tarjeta de contacto (cliente o propietario): nombre, teléfono y email clicables.
 */
export default function CitaBloquePersona({
  etiqueta,
  nombre,
  telefono,
  email,
  clienteId = null,
  contactoId = null,
  c,
  /** @deprecated Preferir phoneColor / emailColor (amarillo / naranja). */
  accentColor = null,
  phoneColor = "#eab308",
  emailColor = "#f97316",
  onLlamarTelefono,
  onAbrirFichaCliente,
  onAbrirFichaContacto,
  onActivarFichaDetras,
  extraDerecha = null,
  /** Contenido junto al teléfono (p. ej. badge «🔑 Llaves»). */
  extraTrasTelefono = null,
  compact = false,
}) {
  const colorTel = phoneColor || accentColor || "#eab308";
  const colorMail = emailColor || accentColor || "#f97316";
  const abrirFicha = () => {
    onActivarFichaDetras?.();
    if (clienteId && typeof onAbrirFichaCliente === "function") {
      onAbrirFichaCliente(clienteId);
      return;
    }
    if (contactoId && typeof onAbrirFichaContacto === "function") {
      onAbrirFichaContacto(contactoId);
    }
  };
  const puedeFicha =
    (clienteId && typeof onAbrirFichaCliente === "function") ||
    (contactoId && typeof onAbrirFichaContacto === "function");

  return (
    <div style={{ padding: compact ? 0 : "10px 14px", borderRadius: compact ? 0 : 10, border: compact ? "none" : `1px solid ${c.border}`, background: compact ? "transparent" : c.bgInput, marginBottom: compact ? 0 : 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: compact ? 4 : 6, flexWrap: "wrap" }}>
        {etiqueta ? (
          <span style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", padding: "2px 8px", borderRadius: 4, background: "rgba(6,182,212,0.12)", color: "#67e8f9" }}>
            {etiqueta}
          </span>
        ) : null}
        <CitaLinkPersona
          nombre={nombre}
          onAbrir={puedeFicha ? abrirFicha : null}
          color={c.textPrimary}
          style={{ fontSize: compact ? 13 : 14 }}
        />
        {extraDerecha}
      </div>
      {(telefono || extraTrasTelefono) ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4, flexWrap: "wrap" }}>
          {telefono ? (
            <>
              <span style={{ fontSize: compact ? 12 : 13 }}>📞</span>
              <CitaLinkTelefono telefono={telefono} onLlamar={onLlamarTelefono} color={colorTel} />
            </>
          ) : null}
          {extraTrasTelefono}
        </div>
      ) : null}
      {email ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
          <span style={{ fontSize: compact ? 12 : 13 }}>✉️</span>
          <CitaLinkEmail email={email} color={colorMail} style={{ fontSize: 12 }} />
        </div>
      ) : null}
    </div>
  );
}
